import http from "../api/http";
import { api } from "../api/environment";
import {
  ServerResponse,
  ITransaction,
  ITransactionClient,
  ITransactionReceipt,
} from "../types/global";

const create = (payload: ITransaction) => {
  const fd = new FormData();
  fd.append("Amount", String(payload.amount));
  fd.append("TransactionType", String(payload.transactionType));
  if (payload.receiptId != null) fd.append("ReceiptId", String(payload.receiptId));
  fd.append("ClientId", String(payload.clientId));
  fd.append("EmployeeCode", payload.employeeCode);
  if (payload.applicant) fd.append("Applicant", payload.applicant);
  fd.append("PaymentMethod", String(payload.paymentMethod));
  if (payload.transferProof) fd.append("transferProof", payload.transferProof);
  return http.post(`/services/app${api.TRANSACTION_SERVICE}/CreateFormData`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getReceipt = (id: number) => {
  return http.get<ITransactionReceipt>(
    `/services/app${api.TRANSACTION_SERVICE}/GetSummaryByReceiptId?receiptId=${id}`
  );
};

const getTransactions = (
  id: number,
  maxResultCount: number,
  skipCount?: number
) => {
  return http.get<ServerResponse<ITransactionClient>>(
    `/services/app${api.TRANSACTION_SERVICE}/GetAllByClientId?clientId=${id}&${
      maxResultCount ? "MaxResultCount=" + maxResultCount + "&" : ""
    }${skipCount ? "SkipCount=" + skipCount + "&" : ""}`
  );
};

const downloadTransferProof = async (id: number): Promise<void> => {
  const response = await http.get(
    `/services/app${api.TRANSACTION_SERVICE}/${id}/TransferProof`,
    { responseType: "blob", transformResponse: [(data) => data] }
  );
  const contentType = String(response.headers["content-type"] || "application/octet-stream");
  const disposition = String(response.headers["content-disposition"] || "");
  const serverName = disposition.match(/filename="?(.+?)"?(?:;|$)/)?.[1];
  const ext = serverName
    ? serverName.substring(serverName.lastIndexOf("."))
    : `.${contentType.split("/")[1]?.replace("jpeg", "jpg") || "bin"}`;
  const blob = new Blob([response.data], { type: contentType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `comprobante-${id}${ext}`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const transactionService = { create, getReceipt, getTransactions, downloadTransferProof };
